<div class="content-wrapper">
  @if (standardLocations()) {
    <mat-card class="content">
      <div class="content-header">
        <h2>
          Alle standaardlocaties <span>({{ totalStandardLocations() }})</span>
        </h2>
        <mat-form-field class="mat-form-field-no-subscript">
          <mat-label class="placeholder">Zoeken</mat-label>
          <input matInput autocomplete="off" placeholder="Zoeken" [formControl]="searchCtrl" />
          <button
            mat-icon-button
            matSuffix
            aria-label="Zoekopdracht wissen"
            (click)="clearSearch(); $event.stopPropagation()"
          >
            <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <mat-table #table [dataSource]="filteredStandardLocations()">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Locatienaam</mat-header-cell>
          <mat-cell *matCellDef="let standardLocation">
            <p class="text-truncate">
              {{ standardLocation.name }}
            </p>
          </mat-cell>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="address">
          <mat-header-cell *matHeaderCellDef>Adres</mat-header-cell>
          <mat-cell *matCellDef="let standardLocation">
            <p class="email text-truncate">
              {{ standardLocation.address }}
            </p>
          </mat-cell>
        </ng-container>

        <!-- Buttons Column -->
        <ng-container matColumnDef="button">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let standardLocation">
            <div class="buttons">
              <button mat-icon-button aria-label="Standaardlocatie bewerken">
                <mat-icon>edit</mat-icon>
              </button>
              <button
                mat-icon-button
                aria-label="Standaardlocatie verwijderen"
                (click)="deleteItem(standardLocation); $event.stopPropagation()"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row
          *matRowDef="let standardLocation; columns: displayedColumns"
          class="user"
          role="button"
          tabindex="0"
          aria-label="Standaardlocatie openen"
          (click)="editItem(standardLocation)"
          (keydown.enter)="editItem(standardLocation)"
          (keydown.space)="$event.preventDefault(); editItem(standardLocation)"
          matRipple
        >
        </mat-row>
      </mat-table>
    </mat-card>
  } @else {
    <div class="content-spinner">
      <mat-spinner></mat-spinner>
    </div>
  }
</div>
